//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegisterForm from '../../../../shared-components/generico/RegisterForm';
import mdAutocomplete from '../../../../shared-components/autocomplete/mdAutocomplete';

export default {
  name: 'EstruturaForm',
  props: {
    prepareResponseData: Function,
  },
  data() {
    return {
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      valid: true,
      required: value => !!value || this.$t('message.campo_obrigatorio'),
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      estruturaUsuario: {
        id: null,
        nomEstruturaUsuario: '',
        indHierarquia: true,
        indRepresentante: false,
        indRateio: false,
        indExtensao: false,
        indAtivo: true,
        idEstruturaUsuarioPai: null,
        estruturaUsuarioPai: '',
      },
    };
  },
  components: {
    mdAutocomplete,
    RegisterForm,
  },
  methods: {
    cancel() {
      this.limparFormulario();
      this.$emit('FORMULARIO_CADASTRO_ESTRUTURA_CANCELAR');
    },
    limparFormulario() {
      this.estruturaUsuario = {
        id: null,
        nomEstruturaUsuario: '',
        indHierarquia: true,
        indRepresentante: false,
        indRateio: false,
        indExtensao: false,
        indAtivo: true,
        idEstruturaUsuarioPai: null,
        estruturaUsuarioPai: '',
      };
      this.$refs.form.reset();
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog(ref, from) {
      if (this.$refs.form.validate()) {
        const content = this.$t('message.salvar_nova_estrutura_usuario');
        this.setDialogContent(content, this.save, from || this.dialog.from);

        this.openDialog(ref || this.dialog.ref);
      }
    },
    save() {
      let salvarOuAtualizar;
      if (this.estruturaUsuario.id != null) {
        salvarOuAtualizar = this.estruturaUsuarioResources
          .atualizar({ id: this.estruturaUsuario.id },
        this.estruturaUsuario);
      } else {
        salvarOuAtualizar = this.estruturaUsuarioResources.gravar(this.estruturaUsuario);
      }

      salvarOuAtualizar.then(() => this.limparFormulario())
      .then(() => this.$toast.create(this.$t('message.adicionado_confira_tabela')
        , 'snack', 3E3))
      .then(() => this.$emit('FORMULARIO_CADASTRO_ESTRUTURA_SALVAR', Object.assign({ }, this.estruturaUsuario)))
      .catch((err) => {
        this.$error(this, err);
      });
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    editar(estruturaUsuario) {
      this.estruturaUsuario = estruturaUsuario;
    },
    setEstruturaUsuarioPai(hit) {
      if (hit.id) {
        this.estruturaUsuario.idEstruturaUsuarioPai = hit.id;
        this.estruturaUsuario.estruturaUsuarioPai = hit.nomEstruturaUsuario;
      } else {
        this.estruturaUsuario.idEstruturaUsuarioPai = null;
        this.estruturaUsuario.estruturaUsuarioPai = '';
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/estrutura-usuario/EstruturaForm.vue?vue&type=script&lang=js&